import { IntercomContext } from 'contexts/intercom';
import { Layout } from 'modules/entrypoint/LayoutCommon';
import type { NotFoundError } from 'navi';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorBlock } from './ErrorBlock';

export const NotFoundBlock = () => {
  const { t } = useTranslation(['common', 'glossary']);
  const { show } = useContext(IntercomContext);

  return (
    <Layout>
      <ErrorBlock
        buttonText={t('glossary:home')}
        handleOpenSupport={show}
        subText={t('common:errorsPages.notFound.subText')}
        text={t('common:errorsPages.notFound.text')}
      />
    </Layout>
  );
};

export const NotFoundLayout = (_: NotFoundError) => <NotFoundBlock />;
